import { useMutation } from '@tanstack/react-query';
import { userClient } from 'src/lib/api';

export const useDeleteUserAccount = () => {
  const mutationFn = (payload) =>
    userClient
      .post('api/v1/user/accountDeletionForShahenWebsite', payload)
      .then((response) => response?.data);
  return useMutation({
    mutationFn,
    onSuccess: () => {},
  });
};

export const useDeleteUserAccountConfirmation = () => {
  const mutationFn = (payload) =>
    userClient
      .post('api/v1/user/accountDeletionConfirmationForShahenWebsite', payload)
      .then((response) => response?.data);
  return useMutation({
    mutationFn,
    onSuccess: () => {},
  });
};
